var React = require('react');

function LiveEvent (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"5","width":"26","height":"18","rx":"1","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M9 27L23 27","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("circle",{"cx":"16","cy":"14","r":"4","fill":"currentColor","key":2})]);
}

LiveEvent.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = LiveEvent;

LiveEvent.default = LiveEvent;
